export const animatePoints = (start, end, setAnimatedPoints, duration = 1500) => {
    const stepTime = 30;
    const steps = Math.ceil(duration / stepTime);
    let current = start;
    let step = (end - start) / steps;

    let count = 0;
    const interval = setInterval(() => {
        current += step;
        count++;
        setAnimatedPoints(Math.round(current));
        if (count >= steps) {
            clearInterval(interval);
            setAnimatedPoints(end);
        }
    }, stepTime);
};